import { render } from "./Streaks.vue?vue&type=template&id=37fb4a97&scoped=true"
import script from "./Streaks.vue?vue&type=script&lang=js"
export * from "./Streaks.vue?vue&type=script&lang=js"

import "./Streaks.vue?vue&type=style&index=0&id=37fb4a97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fb4a97"]])

export default __exports__